import { fetchAPI } from "./baseApi";

export async function getDonations() {
  return fetchAPI("/donations-projects/list", {
    method: "GET",
  });
}

export async function createDonation(data) {
  return fetchAPI("/donations-projects", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function updateDonation(id, data) {
  return fetchAPI(`/donations-projects/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function deleteDonation(id) {
  return fetchAPI(`/donations-projects/${id}`, {
    method: "DELETE",
  });
}
